import type { FC, SVGProps } from 'react';
import Add from './add';
import AddReceipt from './add-receipt';
import Admin from './admin';
import Alert from './alert';
import Allowance from './allowance';
import Analytics from './analytics';
import Arrow from './arrow';
import ArrowLeft from './arrow-left';
import ArrowRight from './arrow-right';
import ArrowsDown from './arrows-down';
import ArrowsLeft from './arrows-left';
import ArrowsRight from './arrows-right';
import ArrowsUp from './arrows-up';
import AutomateRobot from './automate-robot';
import Backward from './backward';
import Basket from './basket';
import Benefit from './benefit';
import BenefitApproval from './benefit-approval';
import Benefits from './benefits';
import BenefitsFill from './benefits-fill';
import Birthday from './birthday';
import BirthdayCake from './birthday-cake';
import BookOpenFill from './book-open-fill';
import BookOpenLine from './book-open-line';
import Buy from './buy';
import Calendar from './calendar';
import Camera from './camera';
import Cash from './cash';
import Cashes from './cashes';
import Categorise from './categorise';
import Chat from './chat';
import Check from './check';
import ChevronDown from './chevron-down';
import CircleFill from './circle-fill';
import Close from './close';
import CloseThick from './close-thick';
import Company from './company';
import Copy from './copy';
import Dashboard from './dashboard';
import DeductMoney from './deduct-money';
import Diamond from './diamond';
import Discounts from './discounts';
import Discounts2 from './discounts-2';
import Document from './document';
import DoubleTick from './double-tick';
import Download from './download';
import DraftLine from './draft-line';
import Dropdown from './dropdown';
import Edit from './edit';
import EmployeeId from './employee-id';
import EndDate from './end-date';
import Enroll from './enroll';
import Enrollment from './enrollment';
import Error_ from './error';
import ExternalLink from './external-link';
import Eye from './eye';
import EyeHide from './eye-hide';
import FileLine from './file-line';
import FileSearchLine from './file-search-line';
import Filter from './filter';
import Forward from './forward';
import Gender from './gender';
import GiftLine from './gift-line';
import Global from './global';
import GroupLine from './group-line';
import Heart from './heart';
import HeartAddFill from './heart-add-fill';
import HeartFill from './heart-fill';
import Hint from './hint';
import Home from './home';
import Id from './id';
import Info from './info';
import LifebuoyLine from './lifebuoy-line';
import Lock from './lock';
import MenuDots from './menu-dots';
import Minus from './minus';
import NotificationOff from './notification-off';
import NotificationOn from './notification-on';
import Policies from './policies';
import Receipts from './receipts';
import Reporting from './reporting';
import Search from './search';
import Security from './security';
import Sell from './sell';
import Shop from './shop';
import SimpleArrowRight from './simple-arrow-right';
import SnowFlake from './snow-flake';
import Star from './star';
import StartDate from './stare-date';
import Status from './status';
import Success from './success';
import Tag from './tag';
import Tick from './tick';
import Trash from './trash';
import Trolley from './trolley';
import { IconScale } from './types';
import Umbrella from './umbrella';
import Unenroll from './unenroll';
import Unlock from './unlock';
import Upload from './upload';
import UploadCloudLine from './upload-cloud-line';
import UserIn from './user-in';
import UserOut from './user-out';
import Users from './users';

export enum IconName {
  Add = 'Add',
  AddReceipt = 'AddReceipt',
  Admin = 'Admin',
  Alert = 'Alert',
  Allowance = 'Allowance',
  Analytics = 'Analytics',
  Arrow = 'Arrow',
  ArrowsDown = 'ArrowsDown',
  ArrowLeft = 'ArrowLeft',
  ArrowsLeft = 'ArrowsLeft',
  ArrowRight = 'ArrowRight',
  ArrowsRight = 'ArrowsRight',
  ArrowsUp = 'ArrowsUp',
  AutomateRobot = 'AutomateRobot',
  Backward = 'Backward',
  Basket = 'Basket',
  Benefit = 'Benefit',
  BenefitApproval = 'BenefitApproval',
  BenefitsFill = 'BenefitsFill',
  Benefits = 'Benefits',
  BirthdayCake = 'BirthdayCake',
  Birthday = 'Birthday',
  BookOpenFill = 'BookOpenFill',
  BookOpenLine = 'BookOpenLine',
  Buy = 'Buy',
  Calendar = 'Calendar',
  Camera = 'Camera',
  Cash = 'Cash',
  Cashes = 'Cashes',
  Categorise = 'Categorise',
  Chat = 'Chat',
  Check = 'Check',
  ChevronDown = 'ChevronDown',
  CircleFill = 'CircleFill',
  Close = 'Close',
  CloseThick = 'CloseThick',
  Company = 'Company',
  Copy = 'Copy',
  Dashboard = 'Dashboard',
  Diamond = 'Diamond',
  DeductMoney = 'DeductMoney',
  Discounts = 'Discounts',
  Discounts2 = 'Discounts2',
  Document = 'Document',
  Download = 'Download',
  DoubleTick = 'DoubleTick',
  Dropdown = 'Dropdown',
  DraftLine = 'DraftLine',
  Edit = 'Edit',
  EmployeeId = 'EmployeeId',
  Enroll = 'Enroll',
  Enrollment = 'Enrollment',
  EndDate = 'EndDate',
  Error = 'Error',
  ExternalLink = 'ExternalLink',
  Eye = 'Eye',
  EyeHide = 'EyeHide',
  FileLine = 'FileLine',
  FileSearchLine = 'FileSearchLine',
  Forward = 'Forward',
  Filter = 'Filter',
  Gender = 'Gender',
  GiftLine = 'GiftLine',
  Global = 'Global',
  GroupLine = 'GroupLine',
  Heart = 'Heart',
  HeartAddFill = 'HeartAddFill',
  HeartFill = 'HeartFill',
  Hint = 'Hint',
  Home = 'Home',
  ID = 'ID',
  Info = 'Info',
  LifebuoyLine = 'LifebuoyLine',
  Lock = 'Lock',
  Minus = 'Minus',
  MenuDots = 'MenuDots',
  NotificationOff = 'NotificationOff',
  NotificationOn = 'NotificationOn',
  Policies = 'Policies',
  Receipts = 'Receipts',
  Reporting = 'Reporting',
  SimpleArrowRight = 'SimpleArrowRight',
  Search = 'Search',
  Security = 'Security',
  Sell = 'Sell',
  SnowFlake = 'SnowFlake',
  StartDate = 'StartDate',
  Star = 'Star',
  Status = 'Status',
  Tag = 'Tag',
  Trash = 'Trash',
  Tick = 'Tick',
  Unlock = 'Unlock',
  Users = 'Users',
  User = 'User',
  Unenroll = 'Unenroll',
  UserIn = 'UserIn',
  UserOut = 'UserOut',
  Upload = 'Upload',
  UploadCloudLine = 'UploadCloudLine',
  Trolley = 'Trolley',
  Shop = 'Shop',
  Success = 'Success',
  Umbrella = 'Umbrella',
}

const IconNameMap = {
  [IconName.Add]: Add,
  [IconName.AddReceipt]: AddReceipt,
  [IconName.Admin]: Admin,
  [IconName.Alert]: Alert,
  [IconName.Allowance]: Allowance,
  [IconName.Analytics]: Analytics,
  [IconName.Arrow]: Arrow,
  [IconName.ArrowsDown]: ArrowsDown,
  [IconName.ArrowLeft]: ArrowLeft,
  [IconName.ArrowsLeft]: ArrowsLeft,
  [IconName.ArrowRight]: ArrowRight,
  [IconName.ArrowsRight]: ArrowsRight,
  [IconName.ArrowsUp]: ArrowsUp,
  [IconName.AutomateRobot]: AutomateRobot,
  [IconName.Backward]: Backward,
  [IconName.Basket]: Basket,
  [IconName.Benefit]: Benefit,
  [IconName.BenefitApproval]: BenefitApproval,
  [IconName.Benefits]: Benefits,
  [IconName.BenefitsFill]: BenefitsFill,
  [IconName.BirthdayCake]: BirthdayCake,
  [IconName.Birthday]: Birthday,
  [IconName.BookOpenFill]: BookOpenFill,
  [IconName.BookOpenLine]: BookOpenLine,
  [IconName.Buy]: Buy,
  [IconName.Calendar]: Calendar,
  [IconName.Camera]: Camera,
  [IconName.Cash]: Cash,
  [IconName.Cashes]: Cashes,
  [IconName.Categorise]: Categorise,
  [IconName.Chat]: Chat,
  [IconName.Check]: Check,
  [IconName.ChevronDown]: ChevronDown,
  [IconName.CircleFill]: CircleFill,
  [IconName.Close]: Close,
  [IconName.CloseThick]: CloseThick,
  [IconName.Company]: Company,
  [IconName.Copy]: Copy,
  [IconName.Dashboard]: Dashboard,
  [IconName.Diamond]: Diamond,
  [IconName.DeductMoney]: DeductMoney,
  [IconName.Discounts]: Discounts,
  [IconName.Discounts2]: Discounts2,
  [IconName.Document]: Document,
  [IconName.Download]: Download,
  [IconName.DoubleTick]: DoubleTick,
  [IconName.Dropdown]: Dropdown,
  [IconName.DraftLine]: DraftLine,
  [IconName.Edit]: Edit,
  [IconName.EmployeeId]: EmployeeId,
  [IconName.Enroll]: Enroll,
  [IconName.Enrollment]: Enrollment,
  [IconName.EndDate]: EndDate,
  [IconName.Error]: Error_,
  [IconName.ExternalLink]: ExternalLink,
  [IconName.Eye]: Eye,
  [IconName.EyeHide]: EyeHide,
  [IconName.FileLine]: FileLine,
  [IconName.FileSearchLine]: FileSearchLine,
  [IconName.Filter]: Filter,
  [IconName.Forward]: Forward,
  [IconName.Trolley]: Trolley,
  [IconName.Gender]: Gender,
  [IconName.GiftLine]: GiftLine,
  [IconName.GroupLine]: GroupLine,
  [IconName.Global]: Global,
  [IconName.Heart]: Heart,
  [IconName.HeartAddFill]: HeartAddFill,
  [IconName.HeartFill]: HeartFill,
  [IconName.Hint]: Hint,
  [IconName.Home]: Home,
  [IconName.Info]: Info,
  [IconName.ID]: Id,
  [IconName.LifebuoyLine]: LifebuoyLine,
  [IconName.Lock]: Lock,
  [IconName.Minus]: Minus,
  [IconName.MenuDots]: MenuDots,
  [IconName.NotificationOff]: NotificationOff,
  [IconName.NotificationOn]: NotificationOn,
  [IconName.Policies]: Policies,
  [IconName.Receipts]: Receipts,
  [IconName.Reporting]: Reporting,
  [IconName.Search]: Search,
  [IconName.Sell]: Sell,
  [IconName.SimpleArrowRight]: SimpleArrowRight,
  [IconName.Security]: Security,
  [IconName.SnowFlake]: SnowFlake,
  [IconName.Shop]: Shop,
  [IconName.StartDate]: StartDate,
  [IconName.Star]: Star,
  [IconName.Status]: Status,
  [IconName.Success]: Success,
  [IconName.Tag]: Tag,
  [IconName.Tick]: Tick,
  [IconName.Trash]: Trash,
  [IconName.Unlock]: Unlock,
  [IconName.Users]: Users,
  [IconName.User]: Users,
  [IconName.Unenroll]: Unenroll,
  [IconName.Upload]: Upload,
  [IconName.UploadCloudLine]: UploadCloudLine,
  [IconName.UserIn]: UserIn,
  [IconName.UserOut]: UserOut,
  [IconName.Umbrella]: Umbrella,
};

interface IIconProps extends SVGProps<HTMLOrSVGElement> {
  name: IconName;
  color?: string;
  fillcolor?: string;
  scale?: IconScale;
  height?: number;
  width?: number;
  className?: string;
  ariaHidden?: boolean;
  'data-testid'?: string;
}

/**
 * @deprecated
 * Please use new RIcon to utilise the remixicons
 */
export const Icon: FC<IIconProps> = ({
  name = IconName.Add,
  color,
  fillcolor,
  scale = IconScale.M,
  height,
  width,
  className,
  ariaHidden,
  ...rest
}: IIconProps) => {
  const IconComponent = IconNameMap[name];

  return (
    <span
      data-testid={rest['data-testid']}
      className={className}
      aria-hidden={ariaHidden}
    >
      <IconComponent
        color={color}
        fillcolor={fillcolor}
        size={scale}
        height={height}
        width={width}
        {...rest}
      />
    </span>
  );
};

export default Icon;
